import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetExampleAudioCachedV1Response } from './get-example-audio-cached-v1-response';
import { getExampleAudioCachedV1ResponseSchema } from './get-example-audio-cached-v1-response';

export async function getExampleAudioCachedV1Api(
  slug: string,
  exampleId: number,
): Promise<IValidatedResponse<IGetExampleAudioCachedV1Response>> {
  return getRequest<IGetExampleAudioCachedV1Response>({
    path: `/challenges/${slug}/audio/example/${exampleId}/cached/v1`,
    schema: getExampleAudioCachedV1ResponseSchema,
  });
}
